// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1tGJp","col":"styles_col__3E0pg"};